<script setup lang="ts">
import type { AdvancedDetectionFilters } from '@/types/filters/DetectionFilters'
import DetectionsAdvancedFilters from '../DetectionsAdvancedFilters.vue'

type Props = {
    filters?: Partial<AdvancedDetectionFilters>
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<AdvancedDetectionFilters>): void
}
defineEmits<Emits>()
</script>

<template>
    <DetectionsAdvancedFilters :filters="filters" @change="$emit('change', $event)" />
</template>

<style scoped lang="scss">
.advanced-datepicker {
    & :deep(.dropdown-content) {
        @media screen and (min-width: 1024px) {
            position: fixed;
        }
    }
    & :deep(.dropdown-menu) {
        @media screen and (max-width: 1023px) {
            margin-top: 7vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            max-height: unset;
        }
    }
}
</style>
